import { registerTheme } from "echarts/core";

const SHARED = {
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
};

const lightTheme: Record<string, unknown> = {
  ...SHARED,
  backgroundColor: "transparent",
  textStyle: { color: "#333" },
  title: { textStyle: { color: "#333" } },
  legend: { textStyle: { color: "#666" } },
  categoryAxis: {
    axisLine: { lineStyle: { color: "#dee2e6" } },
    axisLabel: { color: "#666" },
    splitLine: { lineStyle: { color: "#f1f3f5" } },
  },
  valueAxis: {
    axisLine: { lineStyle: { color: "#dee2e6" } },
    axisLabel: { color: "#666" },
    splitLine: { lineStyle: { color: "#f1f3f5" } },
  },
};

const darkTheme: Record<string, unknown> = {
  ...SHARED,
  backgroundColor: "transparent",
  textStyle: { color: "#c1c2c5" },
  title: { textStyle: { color: "#c1c2c5" } },
  legend: { textStyle: { color: "#909296" } },
  categoryAxis: {
    axisLine: { lineStyle: { color: "#373a40" } },
    axisLabel: { color: "#909296" },
    splitLine: { lineStyle: { color: "#2c2e33" } },
  },
  valueAxis: {
    axisLine: { lineStyle: { color: "#373a40" } },
    axisLabel: { color: "#909296" },
    splitLine: { lineStyle: { color: "#2c2e33" } },
  },
};

registerTheme("pricewatch-light", lightTheme);
registerTheme("pricewatch-dark", darkTheme);

export function getChartThemeName(colorScheme: "light" | "dark"): string {
  return colorScheme === "dark" ? "pricewatch-dark" : "pricewatch-light";
}
